import { Modal as ModalRN } from "react-native";
import React from "react";
import analytics from "../services/analytics";

const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || "Component";

const withTracking = (Component) => {
  class WithTracking extends React.Component {
    constructor(props) {
      super(props);
    }

    trackEvent = async (eventName, eventPayload, suffix = "") => {
      if (eventName && typeof eventName === "string") {
        const payload = typeof eventPayload === "object" ? eventPayload : {};

        // await analytics.trackEvent(`${eventName} ${suffix}`, payload);
      }
    };

    componentDidUpdate = async (prevProps) => {
      if (prevProps.visible !== this.props.visible && !this.props.visible) {
        await this.trackEvent(
          prevProps.eventName,
          prevProps.eventPayload,
          "Closed",
        );
      }
    };

    onShow = async (...args) => {
      if (typeof this.props.onShow === "function") {
        await this.props.onShow(...args);
      }

      await this.trackEvent(
        this.props.eventName,
        this.props.eventPayload,
        "Opened",
      );
    };

    onDismiss = async (...args) => {
      if (typeof this.props.onDismiss === "function") {
        await this.props.onDismiss(...args);
      }

      await this.trackEvent(
        this.props.eventName,
        this.props.eventPayload,
        "Closed",
      );
    };

    render() {
      const { eventName, eventPayload, onShow, forwardedRef, ...rest } =
        this.props;

      return (
        <Component
          ref={forwardedRef}
          onShow={this.onShow}
          onDismiss={this.onDismiss}
          {...rest}
        />
      );
    }
  }

  const forwardRef = (props, ref) => {
    return <WithTracking {...props} forwardedRef={ref} />;
  };

  forwardRef.displayName = `WithTracking(${getDisplayName(Component)})`;
  return React.forwardRef(forwardRef);
};

export const Modal = withTracking(ModalRN);
